import styled from "@emotion/styled";
import { Box, Container } from "@mui/system";
import { ButtonImg } from "components/ui";
import { customPalette } from "shared/palettes";

export const ContainerStyle = styled(Container)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: ${customPalette.primary};
  /* gap: 2em; */
  height: 100%;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    overflow-x: auto;
    padding-left: 0;
    padding-right: 0;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const PanelStyle = styled(Box)`
  width: 3em;
  height: 3rem;
  align-content: center;
  flex-shrink: 0;
  &.selected {
    background: #000033;
  }
`;

export const ButtonImgStyle = styled(ButtonImg)`
  width: 100%;
`;
